module.exports = __webpack_public_path__ + "img/pay-logo.78e06bb7.png";